import { useState, useEffect } from "react";
import "./Login.css";
import { loginAdmin } from "../../services/authServices";
import { useNavigate } from "react-router-dom";

const LOCKOUT_DURATION = 30; // 30 seconds lockout

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [isLocked, setIsLocked] = useState(false);
  const [countdown, setCountdown] = useState(LOCKOUT_DURATION);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (isLocked) {
      setCountdown(LOCKOUT_DURATION);
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setAttempts(0);
            setIsLocked(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isLocked]);

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter both email and password.");
      return;
    }

    if (isLocked) {
      alert("Too many failed attempts. Please try again later.");
      return;
    }

    setIsLoading(true);
    const response = await loginAdmin({ email, password });
    setIsLoading(false);

    if (response.token) {
      localStorage.setItem("token", response.token);
      alert("Login successful!");
      navigate("/ttc/admin");
      window.scrollTo(0, 0);
    } else {
      setAttempts((prev) => prev + 1);
      alert(response.message || "Invalid email or password.");

      if (attempts + 1 >= 3) {
        setIsLocked(true);
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Admin Login</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login-input"
          disabled={isLocked}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
          disabled={isLocked}
        />
        <button
          onClick={handleLogin}
          className="login-button"
          disabled={isLocked || isLoading}
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
        {isLocked && (
          <p className="error-text">
            Too many failed attempts. Try again in{" "}
            <span className="countdown">{countdown}</span> seconds.
          </p>
        )}
      </div>
    </div>
  );
};

export default Login;
